const AccountMapActionTypes = {
	/** ***************** GET ACCOUNT MAPPING DETAILS START *********************** */
	ACCOUNT_MAP_DETAILS_START: 'account_map_details_start',
	ACCOUNT_MAP_DETAILS_SUCCESS: 'account_map_details_success',
	ACCOUNT_MAP_DETAILS_FAILURE: 'account_map_details_failure',
	ACCOUNT_MAP_DETAILS_RESPONSE_RESET: 'account_map_details_response_reset',
	ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED: 'account_map_details_response_changed',
	/** ***************** GET ACCOUNT MAPPING DETAILS END *********************** */

	/** ***************** UPDATE ACCOUNT MAPPING DETAILS START *********************** */
	UPDATE_ACCOUNT_MAP_DETAILS_START: 'update_account_map_details_start',
	UPDATE_ACCOUNT_MAP_DETAILS_SUCCESS: 'update_account_map_details_success',
	UPDATE_ACCOUNT_MAP_DETAILS_FAILURE: 'update_account_map_details_failure',
	UPDATE_ACCOUNT_MAP_DETAILS_RESPONSE_RESET: 'update_account_map_details_response_reset',
	UPDATE_ACCOUNT_MAP_DETAILS_RESPONSE_CHANGED: 'update_account_map_details_response_changed',
	/** ***************** UPDATE ACCOUNT MAPPING DETAILS END *********************** */
};

export default AccountMapActionTypes;
